export default __webpack_public_path__ + "graphics/experience-360@2x.2aad2f32.jpg";